export default __webpack_public_path__ + "static/media/alaska.93b7e446.jpg";